// user reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const PENDING_DATA = 'PENDING_DATA';
export const SET_USER = 'SET_USER';
export const SET_USER_ACCESS = 'SET_USER_ACCESS';
export const LOADING_USER = 'LOADING_USER';
export const LOGIN_MAIL = 'LOGIN_MAIL';
export const USE_TRUE = 'USE_TRUE';
export const USE_FALSE = 'USE_FALSE';
export const VISITOR_I = 'VISITOR_I';
export const USER_FILTER_DATA = 'USER_FILTER_DATA';
export const NEW_MEMBER_DATA = 'NEW_MEMBER_DATA';
export const LOGIN_LOADER = 'LOGIN_LOADER';
export const LOGIN_LOADER_OFF = 'LOGIN_LOADER_OFF';
export const ROOM_LIST = 'ROOM_LIST';
export const ROOM_TRAINING_MANAGEMENT = 'ROOM_TRAINING_MANAGEMENT';
export const LIST_UPDATE = 'LIST_UPDATE';
export const SET_EDIT_USER_LIST = 'SET_EDIT_USER_LIST';
export const ROOMTRAINING_CITY_FILTER = 'ROOMTRAINING_CITY_FILTER';
export const BUILDING_CITY_FILTER = 'BUILDING_CITY_FILTER';
export const TOWER_CITY_FILTER = 'TOWER_CITY_FILTER';
export const FLOOR_CITY_FILTER = 'FLOOR_CITY_FILTER';
export const SEAT_MAPPING_DATA = 'SEAT_MAPPING_DATA';
export const SEAT_EDIT_MAPPING = 'SEAT_EDIT_MAPPING';
export const ROOM_ADD_TRAINING = 'ROOM_ADD_TRAINING';
export const EDIT_ROOM_ADD_TRAINING = 'EDIT_ROOM_ADD_TRAINING';
export const REMOVE_LIST_MAPPING = 'REMOVE_LIST_MAPPING';
export const LOCATION_LIST_ALL = 'LOCATION_LIST_ALL';
export const EXPORT_FILE = 'EXPORT_FILE';
export const ROOM_ALL_GRAPH = 'ROOM_ALL_GRAPH';
export const BUILK_FILE_UPLOAD = 'BUILK_FILE_UPLOAD';
// export const BUILDING_DATA = 'BUILDING_DATA';
export const SEAT_BOOKING_PANNEL = 'SEAT_BOOKING_PANNEL';
export const COMPLIANCE_LEAGLE = 'COMPLIANCE_LEAGLE';
export const COMPLIANCE_DOCUMENT = 'COMPLIANCE_DOCUMENT';
export const COMPLIANCE_FILE_DATA = 'COMPLIANCE_FILE_DATA';
export const COMPLIANCE_SELECT = 'COMPLIANCE_SELECT';
export const COMPANY_LOGO = 'COMPANY_LOGO';
// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'Loading...';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA = 'LOADING_DATA';
export const LOADER_CHECK = 'LOADER_CHECK';
export const LOADER_FALSE = 'LOADER_FALSE';
// Active  Member List
export const BUILDING_FILTER_DATA = 'BUILDING_FILTER_DATA';
export const CITY_FILTER_DATA = 'CITY_FILTER_DATA';
export const MEMBER_LIST = 'MEMBER_LIST';
export const MEMBER_LIST_EDIT = 'MEMBER_LIST_EDIT';
export const BUILDING_SPOC_DATA = 'BUILDING_SPOC_DATA';

// Dashboard-chart---

export const LINE_CHARTDATA = 'LINE_CHARTDATA';
export const BAE_CHARTDATA = 'BAE_CHARTDATA';
export const SEAT_BAR_CHARTDATA = 'SEAT_BAR_CHARTDATA';
export const SEAT_BAR_CHARTDATA_PIE = 'SEAT_BAR_CHARTDATA_PIE';
export const PIE_DATA = 'PIE_DATA';
export const ROOM_DATA = 'ROOM_DATA';
export const PARKING_DATA = 'PARKING_DATA';
export const TICKETING_DATA = 'TICKETING_DATA';
export const TICKET_LIST = 'TICKET_LIST';
// VISITOR
export const VISITOR_LIST = 'VISITOR_LIST';
export const VISITOR_VIEW = 'VISITOR_VIEW';

//SEAT
export const SEAT_LIST = 'SEAT_LIST';
export const SEAT_BOOKING = 'SEAT_BOOKING';
export const SEAT_BOOKING_KPI = 'SEAT_BOOKING_KPI';
export const SEAT_BOOKING_GRAPH = 'SEAT_BOOKING_GRAPH';
export const SEAT_BOOKING_ALL_DATA = 'SEAT_BOOKING_ALL_DATA';



export const ROOM_PHONE_DATA = 'ROOM_PHONE_DATA';
export const INVOICE_LIST = 'INVOICE_LIST';

//ENQUIRY FORM
export const SUBMIT_ENQUIRY_FORM = 'SUBMIT_ENQUIRY_FORM';
export const GET_PRODUCTS_LIST = 'GET_PRODUCTS_LIST';
export const UPDATE_PRODUCT_SERVICES = 'UPDATE_PRODUCT_SERVICES';

// Department
export const GET_DEPARTMENT_OPTIONS = 'GET_DEPARTMENT_OPTIONS';
export const DEPARTMENT_OPTIONS_SUCCESS = 'DEPARTMENT_OPTIONS_SUCCESS';
export const DEPARTMENT_OPTIONS_ERROR = 'DEPARTMENT_OPTIONS_ERROR';

export const GET_DEPARTMENT_LIST = 'GET_DEPARTMENT_LIST';
export const DEPARTMENT_LIST_SUCCESS = 'DEPARTMENT_LIST_SUCCESS';
export const DEPARTMENT_LIST_ERROR = 'DEPARTMENT_LIST_ERROR';

export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_ERROR = 'CREATE_DEPARTMENT_ERROR';

export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_ERROR = 'UPDATE_DEPARTMENT_ERROR';

// Role
export const ROLE_MANAGEMENT_LIST = 'ROLE_MANAGEMENT_LIST';
// export const ROLE_LIST = 'ROLE_LIST';

// Roster
export const GET_SHIFT_START = 'GET_SHIFT_START';
export const SHIFT_START_SUCCESS = 'SHIFT_START_SUCCESS';
export const SHIFT_START_ERROR = 'SHIFT_START_ERROR';

export const GET_SHIFT_END = 'GET_SHIFT_END';
export const SHIFT_END_SUCCESS = 'SHIFT_END_SUCCESS';
export const SHIFT_END_ERROR = 'SHIFT_END_ERROR';

export const GET_DEPARTMENT_USER_DATA = 'GET_DEPARTMENT_USER_DATA';
export const DEPARTMENT_USER_DATA_SUCCESS = 'DEPARTMENT_USER_DATA_SUCCESS';
export const DEPARTMENT_USER_DATA_ERROR = 'DEPARTMENT_USER_DATA_ERROR';

export const GET_COMPANY_SEAT_DATA = 'GET_COMPANY_SEAT_DATA';
export const COMPANY_SEAT_DATA_SUCCESS = 'COMPANY_SEAT_DATA_SUCCESS';
export const COMPANY_SEAT_DATA_ERROR = 'COMPANY_SEAT_DATA_ERROR';

export const POST_SEAT_BOOKING = 'POST_SEAT_BOOKING';
export const POST_SEAT_BOOKING_NEW = 'POST_SEAT_BOOKING_NEW';

export const SEAT_BOOKING_SUCCESS = 'SEAT_BOOKING_SUCCESS';
export const SEAT_BOOKING_ERROR = 'SEAT_BOOKING_ERROR';

export const GET_ROSTER_BOOKING_DATA = 'GET_ROSTER_BOOKING_DATA';
export const ROSTER_BOOKING_DATA_SUCCESS = 'ROSTER_BOOKING_DATA_SUCCESS';
export const ROSTER_BOOKING_DATA_ERROR = 'ROSTER_BOOKING_DATA_ERROR';

export const GET_ROSTER_DEPARTMENT_DATA = 'GET_ROSTER_DEPARTMENT_DATA';
export const ROSTER_DEPARTMENT_DATA_SUCCESS = 'ROSTER_DEPARTMENT_DATA_SUCCESS';
export const ROSTER_DEPARTMENT_DATA_ERROR = 'ROSTER_DEPARTMENT_DATA_ERROR';
export const LOCATION_TYPE = 'LOCATION_TYPE';

export const GET_SEAT_COORDS = 'GET_SEAT_COORDS';

export const AVAILABLE_SEAT_SUCCESS = 'AVAILABLE_SEAT_SUCCESS';
export const AVAILABLE_SEAT_ERROR = 'AVAILABLE_SEAT_ERROR';
export const BUILDING_DATA = 'BUILDING_DATA';
export const TOTAOL_COUNT = 'TOTAOL_COUNT';
export const GET_ASSIGN_SEAT = 'GET_ASSIGN_SEAT';
export const ASSIGN_DATA_SUCCESS = 'ASSIGN_DATA_SUCCESS';

export const ASSIGN_DATA_ERROR = 'ASSIGN_DATA_ERROR';
export const GET_ASSIGN_SEAT_ERROR = 'GET_ASSIGN_SEAT_ERROR';
export const RESET_DATA = 'RESET_DATA';
export const BUILDING_FILTER_DATA1= 'BUILDING_FILTER_DATA1';
export const CITY_FILTER_DATA1 = 'CITY_FILTER_DATA1';
export const BUILDING_DATA1 = 'BUILDING_DATA1';
export const ADD_REVENUE = 'ADD_REVENUE';